import { Amplify } from 'aws-amplify';
import { CookieStorage } from 'aws-amplify/utils';
import { cognitoUserPoolsTokenProvider } from 'aws-amplify/auth/cognito';

const isLocalhost = window.location.hostname === 'localhost';

export const authConfig = {
  userPoolId: 'us-east-1_Su8In0knN',
  userPoolClientId: 'ubun1t50dg73bloct8h0vhm4m',
  identityPoolId: 'us-east-1:7b09fc85-c127-46c5-b750-111e25dd0a8f',
  region: 'us-east-1',
  domain: 'auth.commit.you',
  redirectSignIn: isLocalhost ? 'http://localhost:5173/auth/callback' : 'https://commit.you/auth/callback',
  redirectSignOut: isLocalhost ? 'http://localhost:5173' : 'https://commit.you',
};

// GitHub OAuth configuration
export const githubConfig = {
  clientId: import.meta.env.VITE_GITHUB_CLIENT_ID || '',
  redirectUri: isLocalhost
    ? 'http://localhost:5173/auth/github/callback'
    : 'https://commit.you/auth/github/callback',
  tokenExchangeUrl: import.meta.env.VITE_GITHUB_TOKEN_URL || '',
  scope: 'read:user user:email',
};

// For local development, you can either:
// 1. Use the deployed AppSync API (recommended for MVP)
// 2. Run DynamoDB Local + a local GraphQL server
// 3. Use AWS SAM Local
//
// The AppSync endpoint is obtained from CloudFormation outputs after deployment:
//   aws cloudformation describe-stacks --stack-name commityou-api-dev \
//     --query 'Stacks[0].Outputs[?OutputKey==`GraphQLEndpoint`].OutputValue' --output text
export const apiConfig = {
  // TODO: Replace with your actual AppSync endpoint after deployment
  endpoint: import.meta.env.VITE_GRAPHQL_ENDPOINT || 'https://api.commit.you/graphql',
  region: 'us-east-1',
  defaultAuthMode: 'userPool' as const,
  apiKey: 'da2-i6pj7e7y2vhaxpcqxu7whfupzq',
};

export function configureAmplify() {
  Amplify.configure({
    Auth: {
      Cognito: {
        userPoolId: authConfig.userPoolId,
        userPoolClientId: authConfig.userPoolClientId,
        identityPoolId: authConfig.identityPoolId,
        loginWith: {
          oauth: {
            domain: authConfig.domain,
            scopes: ['email', 'openid', 'profile'],
            redirectSignIn: [authConfig.redirectSignIn],
            redirectSignOut: [authConfig.redirectSignOut],
            responseType: 'code',
            providers: ['Google'],
          },
        },
      },
    },
    API: {
      GraphQL: {
        endpoint: apiConfig.endpoint,
        region: apiConfig.region,
        defaultAuthMode: apiConfig.defaultAuthMode,
        apiKey: apiConfig.apiKey,
      },
    },
  });

  // Configure cookie storage for cross-subdomain authentication
  // Cookies with domain '.commit.you' are shared across all subdomains
  const cookieDomain = isLocalhost ? 'localhost' : '.commit.you';

  cognitoUserPoolsTokenProvider.setKeyValueStorage(
    new CookieStorage({
      domain: cookieDomain,
      path: '/',
      expires: 365,
      sameSite: 'lax',
      secure: !isLocalhost,
    })
  );
}

// Backwards compatibility
export const configureAuth = configureAmplify;
